import { STORAGE_KEYS } from '@shared/constants/storage-keys';

export interface RememberedLogin {
  email: string;
  rememberMe: boolean;
}

export function getRememberedLogin(): RememberedLogin {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.REMEMBERED_LOGIN);
    if (!stored) return { email: '', rememberMe: false };
    const value = JSON.parse(stored) as Partial<RememberedLogin>;
    return typeof value.email === 'string' && value.rememberMe
      ? { email: value.email, rememberMe: true }
      : { email: '', rememberMe: false };
  } catch {
    return { email: '', rememberMe: false };
  }
}

export function useRememberMe() {
  const save = (email: string, rememberMe: boolean) => {
    if (rememberMe)
      localStorage.setItem(
        STORAGE_KEYS.REMEMBERED_LOGIN,
        JSON.stringify({ email, rememberMe: true }),
      );
    else localStorage.removeItem(STORAGE_KEYS.REMEMBERED_LOGIN);
  };
  const clear = () => localStorage.removeItem(STORAGE_KEYS.REMEMBERED_LOGIN);
  return { remembered: getRememberedLogin(), save, clear } as const;
}
